import * as React from 'react'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import type { DriverLeaveSummaryModel } from '@/app/models/timesheet/leaveSummaryModel'


const TimesheetLeaveCounters = ({
  summary,
}: {
  summary: DriverLeaveSummaryModel
}) => {
  const { t } = useLocalize()

  const totalLeaveDays = summary.annualLeaveDays + summary.overdueLeaveDays

  const tooltip = t('timesheet.leave-summary-tooltip')
    .replace('{0}', String(summary.annualLeaveDays))
    .replace('{1}', String(summary.overdueLeaveDays))
    .replace('{2}', String(summary.usedLeaveDays))
    .replace('{3}', String(summary.remainingLeaveDays))

  return (
    <div
      className="tw-flex tw-flex-wrap tw-items-center tw-gap-x-3 tw-gap-y-0.5 tw-text-[11px] tw-leading-tight tw-text-gray-500"
      title={tooltip}
    >
      <span className="tw-whitespace-nowrap">
        {t('driverModule.leave-summary-u')}:{' '}
        <span className="tw-font-medium tw-text-gray-700">
          {summary.usedLeaveDays}/{totalLeaveDays}
        </span>
      </span>
      <span className="tw-whitespace-nowrap">
        {t('driverModule.leave-summary-uz')}:{' '}
        <span className="tw-font-medium tw-text-gray-700">
          {summary.usedOnDemandLeaveDays}/{summary.onDemandLeaveLimit}
        </span>
      </span>
      <span className="tw-whitespace-nowrap">
        {t('timesheet.leave-summary-remaining')}:{' '}
        <span className="tw-font-medium tw-text-gray-700">
          {summary.remainingLeaveDays}
        </span>
      </span>
    </div>
  )
}

export default TimesheetLeaveCounters
